import { Action } from "@ngrx/store";
import { ContenidoStatus, Salutacion } from "src/common/contenido";

export enum SalutacionActionTypes {
	SalutacionPageRequested = '[Salutacion Component] Salutacion Page Requested',
	SalutacionPageLoaded = '[Salutacion API] Salutacion Page Loaded',
	SalutacionPageCancelled = '[Salutacion API] Salutacion Page Cancelled',
	SalutacionPageRight = '[Salutacion API] Salutacion Page Right'
}

export class SalutacionPageRequested implements Action {
	readonly type: string = SalutacionActionTypes.SalutacionPageRequested;
	constructor() {
	}
}

export class SalutacionPageLoaded implements Action {
	readonly type: string = SalutacionActionTypes.SalutacionPageLoaded;
	constructor( public payload: { cleared: boolean, status: ContenidoStatus, salutacion: Salutacion[] } ) {
	}
}

export class SalutacionPageCancelled implements Action {
	readonly type: string = SalutacionActionTypes.SalutacionPageCancelled;
	constructor( public payload: { status: ContenidoStatus } ) {
	}
}

export class SalutacionPageRight implements Action {
	readonly type: string = SalutacionActionTypes.SalutacionPageRight;
	constructor() {
	}
}

export type SalutacionActions = SalutacionPageRequested | SalutacionPageLoaded | SalutacionPageCancelled;